import React, { useState } from 'react';
import classnames from 'classnames';
import { FaChevronDown } from 'react-icons/fa';
import moment from 'moment';
import 'moment/locale/es';
import { getEventCategory, CATEGORY_META } from './calendarEventTypes';

function CalendarFilters({
	eventTypeFilters,
	onEventTypeFilterChange,
	dashboardModules = ['assets', 'contracts', 'debts', 'credits', 'accounts', 'income', 'calendar'],
	googleConnected = false,
}) {
	moment.locale('es');
	const [filtersOpen, setFiltersOpen] = useState(false);

	const eventTypes = [
		{ key: 'contract-expiration', label: 'Vencimientos de Contratos de Alquiler', module: 'contracts' },
		{ key: 'contract-close', label: 'Finalizaciones de Contratos', module: 'contracts' },
		{ key: 'tenant-income', label: 'Ingresos de Inquilinos (inicio de contrato)', modules: ['contracts', 'income'] },
		{ key: 'owner-income', label: 'Ingresos de Propietarios (fecha venta)', modules: ['assets', 'income'] },
		{ key: 'rental-due-expiration', label: 'Cuotas de Alquileres (Pendientes)', module: 'contracts' },
		{ key: 'rental-due-overdue', label: 'Cuotas de Alquileres (Vencidas)', module: 'contracts' },
		{ key: 'debt-due-expiration', label: 'Otras Cuotas (Pendientes) - Deudas', module: 'debts' },
		{ key: 'debt-due-overdue', label: 'Otras Cuotas (Vencidas) - Deudas', module: 'debts' },
		{ key: 'credit-due-expiration', label: 'Otras Cuotas (Pendientes) - Pasividades', module: 'credits' },
		{ key: 'credit-due-overdue', label: 'Otras Cuotas (Vencidas) - Pasividades', module: 'credits' },
		{ key: 'bill-expiration', label: 'Gastos (Pendientes) Vto.', module: 'assets' },
		{ key: 'bill-overdue', label: 'Gastos (Vencidos) Vto.', module: 'assets' },
	].filter(type => {
		// Si tiene modules (array), verificar si al menos uno está habilitado
		if (type.modules && Array.isArray(type.modules)) {
			return type.modules.some(module => dashboardModules.includes(module));
		}
		// Si tiene module (string), verificar si está habilitado
		if (type.module) {
			return dashboardModules.includes(type.module);
		}
		return false;
	}); // Only show checkboxes for enabled modules

	// Google Calendar events aren't gated by dashboardModules — only by connection state
	if (googleConnected) {
		eventTypes.push({ key: 'google-event', label: 'Eventos de Google Calendar' });
	}

	return (
		<div className='calendar-filters mb-4'>
			<button
				type='button'
				onClick={() => setFiltersOpen((open) => !open)}
				className='tw:inline-flex tw:items-center tw:gap-1.5 tw:text-[12.5px] tw:font-medium tw:text-ink-2 tw:hover:text-accent tw:bg-transparent tw:border-0 tw:p-0'
			>
				Filtros
				<FaChevronDown
					size={10}
					className={classnames('tw:transition-transform tw:duration-150', filtersOpen && 'tw:rotate-180')}
				/>
			</button>
			{filtersOpen && (
				<div className='tw:flex tw:flex-wrap tw:gap-2 tw:mt-2'>
					{eventTypes.map(type => {
						const checked = eventTypeFilters[type.key] || false;
						const meta = CATEGORY_META[getEventCategory(type.key)];
						return (
							<button
								key={type.key}
								type='button'
								onClick={() => onEventTypeFilterChange(type.key, !checked)}
								className={classnames(
									'tw:inline-flex tw:items-center tw:gap-1.5 tw:rounded-full tw:border tw:px-3 tw:py-1 tw:text-[11.5px] tw:font-medium tw:transition-colors tw:duration-100',
									checked
										? (meta ? meta.pillActiveClassName : 'tw:bg-accent-soft tw:text-accent-ink tw:border-accent')
										: 'tw:bg-surface tw:text-ink-2 tw:border-border tw:hover:border-border-strong',
								)}
							>
								{meta && (
									<span className={classnames('tw:w-2 tw:h-2 tw:rounded-[2px] tw:shrink-0', meta.dotClassName)} />
								)}
								{type.label}
							</button>
						);
					})}
				</div>
			)}
		</div>
	);
}

export default CalendarFilters;

